module.exports = __webpack_public_path__ + "img/37.3a7b69d0.jpg";